import { useState } from 'react'
import { message } from 'antd'
import { submitFileToCensusV2 } from '../../../api/hris-api-client'
import { isQueuedUpload } from '../../../../CensusManagement/utils/census-upload-job'
import {
  acquireSubmitLock,
  isSubmitLocked,
  releaseSubmitLock,
} from '../utils/submitLock'

export function useSubmitFileToCensusV2() {
  const [loadingFileId, setLoadingFileId] = useState<string | null>(null)

  const submit = async (filePublickey: string, onSuccess?: () => void) => {
    // Hard guard, independent of any React state: catches the case where
    // another tab (or this same tab, before a reload) already has this file
    // mid-submit, even if the button hasn't visually updated to reflect it.
    if (isSubmitLocked(filePublickey)) {
      message.warning(
        'This file is already being submitted — please wait a moment and refresh before trying again.'
      )
      return
    }

    acquireSubmitLock(filePublickey)
    setLoadingFileId(filePublickey)
    try {
      const resp = await submitFileToCensusV2(filePublickey)
      message.success(
        isQueuedUpload(resp)
          ? 'Submit queued. Follow its progress in the Queue section.'
          : 'File submitted successfully'
      )
      onSuccess?.()
      return resp
    } catch (error: any) {
      message.error(`Failed to submit file: ${error.message}`)
      console.error(error)
    } finally {
      releaseSubmitLock(filePublickey)
      setLoadingFileId(null)
    }
  }

  return { submit, loadingFileId }
}
